import { gold, w, AREA_COLORS, SCRIPTURE } from "./constants";

export function ScriptureBar({ section }) {
  const s = SCRIPTURE[section];
  return (
    <div style={{ borderLeft:`3px solid ${gold}`, paddingLeft:12, margin:"0 0 20px", color:w.text2, fontSize:13, fontStyle:"italic" }}>
      "{s.text}" — <strong style={{ fontStyle:"normal", color:gold }}>{s.ref}</strong>
    </div>
  );
}

export function Card({ children, style }) {
  return (
    <div style={{ background:w.bg, border:`0.5px solid ${w.border}`, borderRadius:12, padding:"16px 20px", marginBottom:16, ...style }}>
      {children}
    </div>
  );
}

export function ScoreRow({ label, value, onChange, color }) {
  return (
    <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
      <span style={{ width:110, fontSize:13, color:w.text2 }}>{label}</span>
      <div style={{ display:"flex", gap:4 }}>
        {[1,2,3,4,5,6,7,8,9,10].map(n => (
          <button key={n} onClick={() => onChange(n)} style={{
            width:26, height:26, borderRadius:6,
            border:`0.5px solid ${n <= value ? color : w.border}`,
            background:n <= value ? color : "transparent",
            color:n <= value ? "#fff" : w.text3,
            fontSize:11, cursor:"pointer"
          }}>{n}</button>
        ))}
      </div>
      <span style={{ fontSize:13, fontWeight:500, color:value ? color : w.text3 }}>{value || "—"}</span>
    </div>
  );
}

export function FinanceTable({ label, rows, onChange }) {
  const total = f => rows.reduce((s, r) => s + (parseFloat(r[f]) || 0), 0);
  const diff = r => ((parseFloat(r.actual) || 0) - (parseFloat(r.planned) || 0)).toFixed(0);
  return (
    <Card>
      <h3 style={{ fontSize:14, fontWeight:500, color:gold, margin:"0 0 12px" }}>{label}</h3>
      <table style={{ width:"100%", fontSize:13, borderCollapse:"collapse", tableLayout:"fixed" }}>
        <thead>
          <tr style={{ color:w.text3 }}>
            {["Description","Planned (₹)","Actual (₹)","Diff"].map((h,i) => (
              <th key={h} style={{ textAlign:i===0?"left":"right", paddingBottom:6, fontWeight:400, width:i===0?"35%":undefined }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} style={{ borderTop:`0.5px solid ${w.border}` }}>
              <td style={{ padding:"6px 0" }}><input value={r.desc} onChange={e => onChange(i,"desc",e.target.value)} placeholder="Description" style={{ width:"100%", border:"none", background:"transparent", fontSize:13, color:w.text }} /></td>
              <td><input value={r.planned} onChange={e => onChange(i,"planned",e.target.value)} placeholder="0" style={{ width:"100%", border:"none", background:"transparent", fontSize:13, textAlign:"right", color:w.text }} /></td>
              <td><input value={r.actual} onChange={e => onChange(i,"actual",e.target.value)} placeholder="0" style={{ width:"100%", border:"none", background:"transparent", fontSize:13, textAlign:"right", color:w.text }} /></td>
              <td style={{ textAlign:"right", color:parseFloat(diff(r))>=0?"#3B6D11":"#A32D2D", fontWeight:500 }}>{r.planned||r.actual?diff(r):"—"}</td>
            </tr>
          ))}
          <tr style={{ borderTop:`1px solid ${w.border2}` }}>
            <td style={{ padding:"8px 0", fontWeight:500 }}>Total</td>
            <td style={{ textAlign:"right", fontWeight:500 }}>₹{total("planned").toLocaleString()}</td>
            <td style={{ textAlign:"right", fontWeight:500 }}>₹{total("actual").toLocaleString()}</td>
            <td style={{ textAlign:"right", fontWeight:500, color:total("actual")-total("planned")>=0?"#3B6D11":"#A32D2D" }}>
              {(total("actual")-total("planned")).toFixed(0)}
            </td>
          </tr>
        </tbody>
      </table>
    </Card>
  );
}
